/** 富文本 **/
<template>
  <WangEditor v-model="model[prop]" />
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import WangEditor from './editor/WangEditor.vue'

const props = withDefaults(
  defineProps<{
    model: Record<string, any>
    prop: string
  }>(),
  {}
)
</script>

<style lang="scss" scoped></style>
